<div class="device-not-authorized mt-5">
    <header>
        <img src="/assets/img/brand/mymeds-logo-full.svg" alt="MyMedsPH Logo" class="logo mb-3">
    </header>
    <section class="content mt-3">
        <div class="icon-container mb-4">
            <mat-icon class="error-icon">devices_other</mat-icon>
        </div>
        <h2 class="m-3">Device Unauthorized</h2>
        <h3 class="message">This device is not authorized to access your account.</h3>
        <h4 class="instructions mt-4">Please contact your administrator to approve this device.</h4>
        <div class="row justify-content-center mt-4">
            <div class="col-12 col-sm-6 col-md-3 mb-3">
                <button type="button" class="btn btn-raised btn-primary w-100 hover-btn" (click)="goToLogin()">
                    <mat-icon>login</mat-icon>
                    Back to Login
                </button>
            </div>
        </div>
    </section>
</div>
<footer>
    <p>
        <a href="https://mymedsph.com/">MyMedsPH</a> &nbsp;&nbsp;&nbsp;&nbsp; 0917 705 7827
        &nbsp;&nbsp;&nbsp;&nbsp; info@mymedsph.com
    </p>
</footer>
